module.exports = __webpack_public_path__ + "static/media/logo_dsm.8fd5e9d7.png";